import { queryKeys } from '@/lib/query-keys';
import { invoiceClient } from '@/lib/api/ts-rest';
import { useQuery } from '@tanstack/react-query';
import { useCurrentOrganization } from './useOrganization';

export const useInvoices = () => {
  const { data: organization } = useCurrentOrganization();

  return useQuery({
    queryKey: queryKeys.invoices.list(organization?.id),
    queryFn: async () => {
      if (!organization) {
        throw new Error('No organization selected');
      }
      const res = await invoiceClient.listInvoices({
        params: { organizationId: organization.id },
      });
      if (res.status !== 200) throw new Error('Failed to load invoices');
      return res.body;
    },
    enabled: !!organization,
    refetchOnWindowFocus: true,
    refetchOnMount: true,
    refetchOnReconnect: true,
    staleTime: 0,
  });
};
